import { render, staticRenderFns } from "./home_whiteboard.vue?vue&type=template&id=9f1b1d46&scoped=true"
import script from "./home_whiteboard.vue?vue&type=script&lang=js"
export * from "./home_whiteboard.vue?vue&type=script&lang=js"
import style0 from "./home_whiteboard.vue?vue&type=style&index=0&id=9f1b1d46&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1b1d46",
  null
  
)

export default component.exports